import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { TTL } from "../../Lib/Utils/TTL";
import { IApiResponse, ICountryCodes } from "../../Orchestrator/Types/Index";

export async function getCountryCodes(): Promise<IApiResponse<ICountryCodes[]>> {
    const endpoints = await getEndpoints();
    return await apiRequest<ICountryCodes[]>(endpoints?.getCountryCodes, "GET", undefined, "classic", TTL.DAY);
}